import React from 'react'

interface InteractiveQuizProps {
  data: any
  onComplete: () => void
}

const InteractiveQuiz: React.FC<InteractiveQuizProps> = ({ data, onComplete }) => {
  return (
    <div className="brilliant-card p-8">
      <h2 className="text-3xl font-bold text-dark-900 mb-4 text-center">
        {data.title}
      </h2>
      <p className="text-dark-700 text-lg mb-6">
        {data.instruction}
      </p>
      <button
        onClick={onComplete}
        className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold text-lg rounded-xl hover:from-blue-700 hover:to-cyan-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-2xl"
      >
        ✓ Tiếp tục
      </button>
    </div>
  )
}

export default InteractiveQuiz
